import { render } from "./CanalComposer.vue?vue&type=template&id=67c03e92&scoped=true"
import script from "./CanalComposer.vue?vue&type=script&lang=js"
export * from "./CanalComposer.vue?vue&type=script&lang=js"

import "./CanalComposer.vue?vue&type=style&index=0&id=67c03e92&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67c03e92"]])

export default __exports__